import { TextareaAutosize, Typography } from "@mui/material";

import React, { useEffect } from "react";
const FluxPuLIDSettings = ({
  onSettingsChange,
  selectedPrompt,
  generateExact,
}) => {
  const [settings, setSettings] = React.useState({
    prompt: selectedPrompt?.prompt || "",
    negativePrompt: "",
    seed: "",
    numInferenceSteps: 20,
    guidanceScale: 4.0,
    idWeight: 1.0,
    trueGuidanceScale: 3.0,
    width: 1024,
    height: 1024,
    numImages: 1,
    enableSafetyChecker: true,
    aspectRatio: "1:1",
  });
  useEffect(() => {
    // Update settings when selectedPrompt changes
    if (selectedPrompt?.prompt) {
      handleSettingChange("prompt", selectedPrompt.prompt || "");
    } else {
      handleSettingChange("prompt", "");
    }
  }, [selectedPrompt?.prompt]);

  useEffect(() => {
    // Convert aspectRatio to aspect_ratio for API compatibility
    const apiSettings = { ...settings };
    if (apiSettings.aspectRatio) {
      apiSettings.aspect_ratio = apiSettings.aspectRatio;
      delete apiSettings.aspectRatio;
    }
    onSettingsChange?.(apiSettings);
  }, []);

  const handleSettingChange = (key, value) => {
    const newSettings = { ...settings, [key]: value };
    setSettings(newSettings);

    // Convert aspectRatio to aspect_ratio for API compatibility
    const apiSettings = { ...newSettings };
    if (apiSettings.aspectRatio) {
      apiSettings.aspect_ratio = apiSettings.aspectRatio;
      delete apiSettings.aspectRatio;
    }

    onSettingsChange?.(apiSettings);
  };

  return (
    <div className="space-y-4">
      <div>
        <Typography className="text-gray-300">Prompt</Typography>
        <TextareaAutosize
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white resize-none"
          rows={3}
          placeholder="Describe the image you want to generate..."
          value={settings.prompt}
          onChange={(e) => handleSettingChange("prompt", e.target.value)}
        />
        <p className="text-xs text-gray-400 mt-1">
          Describe the image style and content (identity will be preserved from
          reference image)
        </p>
      </div>

      <div>
        <Typography className="text-sm font-medium text-gray-300">
          Aspect Ratio
        </Typography>
        <select
          value={settings.aspectRatio}
          onChange={(e) => handleSettingChange("aspectRatio", e.target.value)}
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white"
        >
          <option value="1:1">Square (1:1)</option>
          <option value="16:9">Landscape (16:9)</option>
          <option value="9:16">Portrait (9:16)</option>
          <option value="4:3">Classic (4:3)</option>
          <option value="3:4">Portrait Classic (3:4)</option>
          <option value="3:2">Landscape (3:2)</option>
          <option value="2:3">Portrait (2:3)</option>
          <option value="5:4">Classic Wide (5:4)</option>
          <option value="4:5">Classic Tall (4:5)</option>
          <option value="21:9">Ultrawide (21:9)</option>
        </select>
        <p className="text-xs text-gray-400 mt-1">
          Choose the aspect ratio for the generated image
        </p>
      </div>
    </div>
  );
};

export default FluxPuLIDSettings;
